import React from "react";
import { IBasketTempItem } from "../../../../../redux/cart/basketTemp/slice";
import { ITempProfileData } from "../../../../../redux/profile/tempProfiles/slice";
import { GiftSection } from "../GiftSection";
import { Button } from "../../../../../components";
import styles from "./GiftView.module.scss";

interface GiftViewProps {
  basketTemp: IBasketTempItem[];
  tempProfilesData: { [profileId: string]: ITempProfileData };
  updateProfile: (profileId: string, field: keyof ITempProfileData, value: string) => void;
  deliveryDate: string;
  setShowCalendar: (show: boolean) => void;
  validateProfile?: (profileData: ITempProfileData, isReceiver: boolean) => boolean;
}

export const GiftView: React.FC<GiftViewProps> = ({
  basketTemp,
  tempProfilesData,
  updateProfile,
  deliveryDate,
  setShowCalendar,
  validateProfile,
}) => {
  const giftSubscription = basketTemp.find((item) => item.type === "gift");
  const price = giftSubscription?.price;

  const formatPrice = (value?: number) => {
    if (value == null) return undefined;
    if (typeof value === "number") return value.toLocaleString("ru-RU");
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed.toLocaleString("ru-RU") : value;
  };

  const receiverAdditionalFields = [
    {
      type: "email" as const,
      label: "Email",
      placeholder: "info@info.ru",
      key: "email" as keyof ITempProfileData,
    },
    {
      type: "default" as const,
      label: "Поздравление",
      placeholder: "Поздравляю с днем рождения!",
      key: "message" as keyof ITempProfileData,
      multiline: true,
    },
  ];

  return (
    <div className={styles.giftView}>
      <GiftSection
        title="Отправитель"
        subtitle={price !== undefined ? `${formatPrice(price)} ₽` : undefined}
        buttonText="Взрослый №1"
        profileId="sender"
        profileType="adult"
        profileNumber={1}
        tempProfilesData={tempProfilesData}
        updateProfile={updateProfile}
        validateProfile={validateProfile}
      />

      <GiftSection
        title="Получатель"
        buttonText="Взрослый №2"
        profileId="receiver"
        profileType="adult"
        profileNumber={2}
        tempProfilesData={tempProfilesData}
        updateProfile={updateProfile}
        validateProfile={validateProfile}
        additionalFields={receiverAdditionalFields}
      />

      <div className={styles.deliveryInfo}>
        <p className={styles.deliveryText}>
          Дата доставки: {deliveryDate || "Не выбрана"}
        </p>
        <Button onClickFunc={() => setShowCalendar(true)}>Выбрать дату</Button>
      </div>
    </div>
  );
};

